const orientation = "portrait";

module.exports = orientation;
